"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

var _Message = _interopRequireDefault(require("../Message"));

var _KeyGen = require("../KeyGen");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.75em;\n  margin-top: 0.25em;\n  line-height: 1.7;\n  letter-spacing: 0.5px;\n  height: 1em;\n  display: inline-block;\n  margin-right: 10px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  padding: 0;\n  min-height: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  padding: 0.5em;\n  margin: 0;\n  border: 1px solid ", ";\n  min-height: 88px;\n  font-size: 1em;\n  line-height: 1.5em;\n  resize: vertical;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25em;\n  font-size: 0.75em;\n  letter-spacing: 0.5px;\n\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents.default.label(_templateObject());

var Wrapper = _styledComponents.default.div(_templateObject2());

var TextArea = _styledComponents.default.textarea(_templateObject3(), function (props) {
  return props.error ? props.theme.colorError : props.theme.colorBorder;
}, function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
});

var ReadOnly = (0, _styledComponents.default)(TextArea)(_templateObject4());

var Subtext = _styledComponents.default.div(_templateObject5());

var Textarea = /*#__PURE__*/function (_React$Component) {
  _inherits(Textarea, _React$Component);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Textarea).call(this, props));
    _this.fallbackError = 'Value is unexpected.';
    var validationErrors = Object.assign({
      patternMismatch: 'Value is unexpected.',
      rangeOverflow: 'Value is too large.',
      rangeUnderflow: 'Value is too small.',
      stepMismatch: 'This is an invalid step interval value.',
      tooLong: 'Value is too long.',
      tooShort: 'Value is too short.',
      typeMismatch: 'Value is not the correct format.',
      valueMissing: 'This field is required.',
      fallback: _this.fallbackError
    }, props.validationErrors);
    var hasError = props.error && props.error.length;
    _this.state = {
      isValid: !hasError,
      error: hasError ? props.error : null,
      // error message string
      dirty: hasError,
      validationErrors: validationErrors
    };
    _this.counterId = (0, _KeyGen.getKey)();
    _this.checkValidity = _this.checkValidity.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Textarea, [{
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        dirty: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      this.checkValidity(false);
      this.setState({
        dirty: true
      });
      this.props.onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.maxCharacters !== null && e.target.value.length >= parseInt(this.props.maxCharacters, 10) && // don't block the delete key
      e.keyCode !== 8) {
        e.preventDefault();
        e.stopPropagation();
      }

      this.props.onKeyDown(e);
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      if (this.charCountElement) {
        this.charCountElement.innerHTML = this.getMaxCharLabel(this.props.maxCharacters, this.props.readonly, e.target.value.length);
      }

      this.props.onChange(e);
    }
  }, {
    key: "getMaxCharLabel",
    value: function getMaxCharLabel(maxChars) {
      var readonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var numChars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var label = "".concat(maxChars, " character limit");
      return readonly ? label : "".concat(label, " (").concat(numChars, " used)");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.error !== this.props.error) {
        // if error is truthy, fire off an error, otherwise recheck it
        if (this.props.error && this.props.error.length) {
          this.setState({
            isValid: false,
            error: this.props.error,
            dirty: true
          });
        } else {
          this.setState({
            isValid: true,
            error: this.props.error
          }, function () {
            return _this2.checkValidity(false);
          });
        }
      }
    }
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var calledExternally = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = this.props,
          error = _this$props.error,
          validators = _this$props.validators,
          onValid = _this$props.onValid,
          onInvalid = _this$props.onInvalid;
      var validationErrors = this.state.validationErrors;
      var fallbackError = this.fallbackError;
      var input = this.input;
      var validity = input.validity;
      var isValid = !error;
      var errorType = error ? 'supplied' : null;
      var errorMessage = error || null; // if there's not an error yet AND the field is dirty AND we have browser support...

      if (isValid && (this.state.dirty || calledExternally) && validity) {
        isValid = validity.valid;
      } // if we're valid so far, run the custom validation


      if (isValid && validators) {
        Object.keys(validators).forEach(function (key) {
          // the "!!" gets us a boolean, regardless of what comes back
          var customIsValid = !!validators[key](input.value);
          isValid = isValid && customIsValid;

          if (!customIsValid) {
            errorType = key;
            errorMessage = validationErrors[key] || validationErrors['fallback'] || fallbackError;
          }
        });
      } // when there's an error


      if (!isValid) {
        // find the right error message
        if (!errorMessage) {
          // try to find a known message (via the HTML5 validity API)
          Object.keys(validationErrors).forEach(function (key) {
            if (typeof validity[key] !== 'undefined' && validity[key] === true) {
              errorType = key;
              errorMessage = validationErrors[key];
            }
          }); // if we can't find one, go with the fallback

          if (!errorMessage) {
            errorType = 'unknown';
            errorMessage = validationErrors.fallback;
          }
        } // invalid callback


        onInvalid(input.value, errorType);
      } else {
        // valid callback
        onValid(input.value);
      }

      this.setState({
        isValid: isValid,
        error: errorMessage,
        dirty: true
      });
      return isValid;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id,
          name = _this$props2.name,
          defaultValue = _this$props2.defaultValue,
          value = _this$props2.value,
          label = _this$props2.label,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          required = _this$props2.required,
          maxCharacters = _this$props2.maxCharacters,
          readonly = _this$props2.readonly,
          theme = _this$props2.theme;
      var isValid = this.state.isValid;
      var characterCounter = '';
      var title = label ? _react.default.createElement(Label, {
        htmlFor: id,
        className: 'hw-textarea-label',
        "aria-disabled": disabled
      }, label, required && ' *') : null;

      if (maxCharacters) {
        value = value && value.length ? value.substring(0, maxCharacters) : null;
        characterCounter = _react.default.createElement(Subtext, {
          id: this.counterId,
          ref: function ref(el) {
            _this3.charCountElement = el;
          },
          className: 'hw-textarea-counter'
        }, this.getMaxCharLabel(maxCharacters, readonly));
      }

      var errorLabel = error || !isValid ? _react.default.createElement(Subtext, {
        className: "hw-text-area-error-container"
      }, _react.default.createElement(_Message.default, {
        className: (0, _classnames.default)('hw-text-area-error', "".concat(className, "-error")),
        type: "error",
        showIcon: false
      }, this.state.error)) : null; // if it's readonly, just display the text

      var textarea = readonly ? _react.default.createElement(ReadOnly, {
        as: "p",
        className: 'hw-textarea-textarea hw-textarea-textarea-readonly'
      }, value || defaultValue || '') : _react.default.createElement(Wrapper, {
        className: 'hw-textarea-textarea-wrapper'
      }, _react.default.createElement(TextArea, {
        className: 'hw-textarea-textarea',
        ref: function ref(el) {
          _this3.input = el;
        },
        id: id,
        name: name,
        defaultValue: defaultValue,
        value: value,
        disabled: disabled,
        error: error || !isValid,
        required: required,
        "aria-required": required,
        "aria-describedby": this.counterId,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        theme: theme
      }), characterCounter, errorLabel);
      return _react.default.createElement("div", {
        className: 'hw-textarea',
        "aria-disabled": disabled
      }, title, textarea);
    }
  }]);

  return Textarea;
}(_react.default.Component);

Textarea.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  value: _propTypes.default.string,
  label: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.string,
  required: _propTypes.default.bool,
  maxCharacters: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onChange: _propTypes.default.func,
  readonly: _propTypes.default.bool,
  theme: _propTypes.default.shape({
    colorBorder: _propTypes.default.string,
    colorError: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string
  })
};
Textarea.defaultProps = {
  id: (0, _KeyGen.getKey)(),
  defaultValue: undefined,
  value: undefined,
  readonly: false,
  disabled: false,
  maxCharacters: null,
  onFocus: function onFocus(e) {
    return e;
  },
  onBlur: function onBlur(e) {
    return e;
  },
  onKeyDown: function onKeyDown(e) {
    return e;
  },
  onChange: function onChange(e) {
    return e;
  },
  onValid: function onValid(val) {
    return val;
  },
  onInvalid: function onInvalid(val, errType) {
    return {
      val: val,
      errType: errType
    };
  },
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(Textarea);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/TextArea/index.js